import * as Common from '@/tenant/common';

export class Charge extends Common.StateObject{
  constructor(){
    super('Charge');
    this.binders.segment = new Common.ModelBinder(Common.Segment);
    this.binders.counterpart = new Common.ModelBinder(Common.Counterpart);
    this.binders.account = new Common.ModelBinder(Common.Account);
    this.binders.paymentBalance = new Common.ModelBinder(Common.TransferBalance);
    this.workflowCode="charge";
    this.state = ChargeStatus.ChargeSaving;
    this.workflowStateId = ChargeStatus.ChargeSaving;
  }
  public get actionTooltip() {
    if (this.state == ChargeStatus.ChargeSaving)　return '支払へ進む場合は【確定】をクリックします。';
    else if (this.state == ChargeStatus.PaymentWaiting) return '支払を行う場合は【上部メニュー】の【支払処理】をクリックします。';
    else if (this.state == ChargeStatus.Paying) return '支払を行う場合は【上部メニュー】の【支払処理】をクリックします。';     
    else if (this.state == ChargeStatus.Completed) return '諸掛内容を訂正する場合は、作成した支払伝票を削除してから【確定取消】をクリックします。';         
    else return '';
  }  
  public chargeNo: string = '';
  public chargeFlag: Common.SalesPurchaseFlags = Common.SalesPurchaseFlags.Purchase;
  public segmentId: number = 0;
  public segment: Common.Segment = null;
  public pic: string = null;
  public refNo: string = null;
  public counterpartId: number = 0;
  public counterpart: Common.Counterpart = null;
  public chargeDate: Date = new Date().getCalendarDate();
  public target: Common.ChargeItemTypes = 0;
  public currencyCode: string = null;
  public exchangeRate: number = 1;
  public proportionalDivision: ProportionalDivisionFlags = ProportionalDivisionFlags.Excluded;
  public accountCode: string = null;
  public account: Common.Account = null;
  public taxCode: string = null;
  public description: string = '';
  public deliveryNo: string = '';
  public dueDate: Date = null;

  // 金額
  public dealAmountFC: number = 0;
  public amountFC: number = 0;
  public taxAmountFC  : number = 0;
  public amount: number = 0;
  public taxAmount: number = 0;

  // 支払残高管理
  public paymentBalanceId: number = null;
  public paymentBalance: Common.TransferBalance = null;
  public writeoffAmountFC: number = 0;
  
  public get target2() {return this.target;}
  public set target2(value: Common.ChargeItemTypes) { this.target = value; this.proportionalDivision = value == Common.ChargeItemTypes.Default ? ProportionalDivisionFlags.Excluded : null; }
  public get linkCharge() {
      if (this.chargeFlag == Common.SalesPurchaseFlags.Sales) return String.format('/sales/SalesCharge?chargeNo={0}', this.chargeNo);
      else return String.format('/purchase/PurchaseCharge?chargeNo={0}', this.chargeNo);
  }
  public get linkFormatDelivery() {
      if (this.chargeFlag == Common.SalesPurchaseFlags.Sales) return '/sales/SalesDelivery?deliveryNo={0}';
      else return '/purchase/PurchaseDelivery?deliveryNo={0}';
  }
  public copy():any {
    const temp = super.copy() as Charge;
    temp.chargeNo = '';
    temp.deliveryNo = '';
    temp.state = ChargeStatus.ChargeSaving;
    temp.workflowStateId = ChargeStatus.ChargeSaving;
    temp.paymentBalance = null;
    temp.dealAmountFC = 0;
    return temp;
  }
}

export enum ChargeStatus
{
  ChargeSaving = 1, // 確定待ち
  PaymentWaiting = 2, // 支払処理待ち
  Paying = 4, // 支払処理中
  Completed = 8, // 完了
  NotCompleted = ChargeSaving | PaymentWaiting | Paying
}

export enum ProportionalDivisionFlags
{
  ByQuantity,
  ByAmount, 
  ByWeight,
  ByVolume,
  Excluded
}

export class SalesCharge extends Charge{
  constructor(){
    super()
    this.chargeFlag = Common.SalesPurchaseFlags.Sales;
    this.target = Common.ChargeItemTypes.Default;
  }

  public copy():any {
    const temp = super.copy() as SalesCharge;
    return temp;
  }
}

export class PurchaseCharge extends Charge{
  constructor(){
    super()
    this.chargeFlag = Common.SalesPurchaseFlags.Purchase;
    this.target = Common.ChargeItemTypes.Default;
  }

  public copy():any {
    const temp = super.copy() as PurchaseCharge;
    return temp;
  }
}

export class ChargeQuery extends Common.LoadQuery {
  constructor(chargeFlag: Common.SalesPurchaseFlags){
    super('ChargeQuery', chargeFlag == Common.SalesPurchaseFlags.Purchase ? PurchaseCharge : SalesCharge);
    this.chargeFlag = chargeFlag;
    this.state = Common.ChargeStatus.NotCompleted;
    this.sort = 'chargeNo';
  }
  public chargeFlag: Common.SalesPurchaseFlags = Common.SalesPurchaseFlags.Purchase;
  public segment:  Common.Segment = null;
  public counterpart: Common.Counterpart = null;
  public account: Common.Account = null;
  public pic: string = "";
  public chargeNo: string = '';
  public deliveryNo: string = ''; //諸掛明細タブで使用
  public refNo: string = '';
  public description: string = '';
  public currencyCode:string = '';
  public chargeDateFrom: Date = null;
  public chargeDateTo: Date = null;
  public initialSavedOnFrom: Date = null;
  public initialSavedOnTo: Date = null;
  public lastUpdatedOnFrom: Date = null;
  public lastUpdatedOnTo: Date = null;
  public state: Common.ChargeStatus = Common.ChargeStatus.NotCompleted;
  public holder: string = "";
  public partialInclude:boolean = false;  
}

export class ChargeImportQuery extends Common.ImportQuery {
  constructor(sheetName:string, chargeFlag:number){
    super("",null);
    this.className = "ChargeImportQuery";
    this.sheetName = sheetName;
    this.chargeFlag = chargeFlag;
  }
  public sheetName  :string;
  public chargeFlag : number;
}
export class ChargeExportQuery extends Common.ExportQuery {
  constructor(sheetName:string, loadQuery:Common.LoadQuery, chargeFlag:number){
    super("",loadQuery);
    this.className = "ChargeExportQuery";
    this.loadQuery = loadQuery;
    this.sheetName = sheetName;
    this.chargeFlag = chargeFlag;
  }
  public loadQuery : Common.LoadQuery;
  public sheetName  :string;
  public chargeFlag : number;
  public hasLicenseCurrency: boolean;
}

export class ChargePaymentJouralQuery extends Common.LoadQuery {
  constructor(){
    super('ChargePaymentJouralQuery',Charge);
  }
  public charge: Charge;
} 

export class ChargePaymentQuery extends Common.Query {
  constructor(){
    super('ChargePaymentQuery',new Common.ModelBinder(Charge,false));
  }
  public isSalesCharge: boolean = false;
  public segment: Common.Segment = null;
  public pic: string = '';
  public counterpart: Common.Counterpart;
  public currencyCode: string = '';
  public paymentDate: Date;
  public bankAccount: Common.BankAccount = null;
  public exchangeRate: number = 0;
  public commissionAmountFC: number = 0;
  public settlementAmountFC: number = 0;
  public commissionTaxFlag: boolean = false;
  public workflowId:number = 0;
  public charges: Array<Common.Charge>;
  public actionId:number = 0;
} 

export class AddDeliveryChargeItemQuery extends Common.Query{
  constructor(){
    super('AddDeliveryChargeItemQuery',new Common.ModelBinder(Charge,false));
  }
  public charge: Common.Charge = null;
  public deliveryItems: Array<Common.DeliveryItem> = new Array();
}

export class AddStockChargeItemQuery extends Common.Query{
  constructor(){
    super('AddStockChargeItemQuery',new Common.ModelBinder(Charge,false));
  }
  public charge: Common.Charge = null;
  public stockBalances: Array<Common.StockBalance> = new Array();
}

export class DeleteChargeItemQuery extends Common.Query{
  constructor(){
    super('DeleteChargeItemQuery',new Common.ModelBinder(Charge,false));
  }
  public charge: Common.Charge = null;
  public chargeItemId: number = null;
}

export class AddChargeAllocationQuery extends Common.Query{
  constructor(){
    super('AddChargeAllocationQuery',new Common.ModelBinder(Charge,true));
  }
  public charges: Array<Common.Charge> = new Array();
  public deliveryItems: Array<Common.DeliveryItem> = new Array();
  public actionId: number = 0;
  public allocationOnly:boolean = false;  
}

export class AddStockChargeAllocationQuery extends Common.Query{
  constructor(){
    super('AddStockChargeAllocationQuery',new Common.ModelBinder(Charge,true));
  }
  public charges: Array<Common.Charge> = new Array();
  public stockBalances: Array<Common.StockBalance> = new Array();
  public actionId: number = 0;
  public allocationOnly:boolean = false;
}